export interface CSLiveAnalysisContext {
  deviceId: number;
  from: string;
  to: string;
  pageId: number;
  projectId: number;
  segmentId: number;
  segmentInclude: boolean;
  url: string;
}

export interface AnalysisContext {
  project: number;
  device: number;
  from: string;
  to: string;
  segmentFov: any;
  mapping: number;
  page: number;
  urlRegex: string;
}

export interface CSLiveZone {
  zoneId: number;
  midZoneHeight: number;
  targets: string[];
  dimension: { height: number; width: number };
}

export interface Zone {
  id: number;
  targets: string[];
  midZoneHeight: number;
  fromCsLive: boolean;
}

export function formatAnalysisContext(context: CSLiveAnalysisContext): AnalysisContext {
  return {
    project: context.projectId,
    device: context.deviceId,
    segmentFov: {
      children: [
        {
          children: [
            {
              nodeType: 'filter',
              field: 'segment:id',
              operator: context.segmentInclude ? 'equals' : 'not_equals',
              value: context.segmentId || -1,
            },
          ],
          nodeType: 'AND',
        },
      ],
      nodeType: 'AND',
    },
    from: context.from,
    to: context.to,
    mapping: -1,
    page: context.pageId,
    urlRegex: context.url,
  };
}

export function formatZone(zone: CSLiveZone): Zone {
  return {
    id: zone.zoneId,
    targets: zone.targets,
    midZoneHeight: zone.midZoneHeight,
    fromCsLive: true,
  };
}
